import { useEffect } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { setGenderOptions } from "web/redux/ducks/feed-sidebar";
import { UniversalFiltersData, InputFilterOption } from "web/types/universal-filters";
import { ReduxStoreState } from "web/redux/store";

export function extractGenderFromFilters(
    filters: UniversalFiltersData
): InputFilterOption[] | undefined {
    let maybeGender = filters.filter_section_list[0];

    // Work on the assumption that the gender can only ever be in the top slot.
    if (!maybeGender || maybeGender.id != "section-gender") {
        return;
    }

    return maybeGender.option_groups[0].options as any;
}

/**
 * Makes sure the external gender switcher has the right info
 */
export function useExternalGender(activeFilters: UniversalFiltersData): void {
    const dispatch = useDispatch();

    useEffect(() => {
        // Find out if we've been sent any genders by the server
        let genders = extractGenderFromFilters(activeFilters);
        if (genders) {
            // Store avaiable genders in redux so the user can switch more easily
            dispatch(setGenderOptions(genders));
        }
        // We only care about when the first filter section changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters.filter_section_list[0]]);
}

function extractSelectedGender(state: ReduxStoreState): InputFilterOption | null {
    return state.feedSidebarReducer.selectedGender;
}

export function useSelectedGender(): InputFilterOption | null {
    return useReduxSelector(extractSelectedGender);
}
